import { Menu, MenuItem, Divider } from '@mui/material';
import SmileIcon from '@mui/icons-material/EmojiEmotions';
import HistoryIcon from '@mui/icons-material/History';
import PeopleIcon from '@mui/icons-material/People';
import LogoutIcon from '@mui/icons-material/Logout';
import { isInApp } from '../utils/environment';
export default function UserMenu({ anchorEl, open, onClose, navigate, onLogout }) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(80,80,180,0.12)',
          minWidth: 180,
          mt: 1,
          p: 0.5
        }
      }}
      disableScrollLock
    >
      <MenuItem onClick={() => { navigate('/campaigns/invitations/referral'); onClose(); }}>
        <SmileIcon sx={{ color: '#000', mr: 1 }} />
        Invite & Earn
      </MenuItem>
      <MenuItem onClick={() => { navigate('/campaigns/invitations/invitations-records'); onClose(); }}>
        <PeopleIcon sx={{ color: '#000', mr: 1 }} />
        My Invitees
      </MenuItem>
      <MenuItem onClick={() => { navigate('/campaigns/invitations/withdrawal-records'); onClose(); }}>
        <HistoryIcon sx={{ color: '#000', mr: 1 }} />
        Earnings & Payouts
      </MenuItem>
     
      {
        !isInApp() && (
          <MenuItem onClick={onLogout} sx={{ borderTop: '1px solid #E2E8F0' }}>
            <LogoutIcon sx={{ color: '#000', mr: 1 }} />
            Logout
          </MenuItem>
        )
      }
    </Menu>
  );
} 